import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { FETCH_CONTACT_CARD_FAILURE, FETCH_CONTACT_CARD_REQUEST, FETCH_CONTACT_CARD_SUCCESS } from "../../actions/opportunities/contactMapCardActions";

  const initialState = {
    contactCardLoading: false,
    contactCardData: [],
    contactCardError: null,
  };
  
  const contactCardReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CONTACT_CARD_REQUEST:
        return { ...state, contactCardLoading: true , payload: action.payload};
      case FETCH_CONTACT_CARD_SUCCESS:
        return { ...state, contactCardLoading: false, contactCardData: action.payload };
      case FETCH_CONTACT_CARD_FAILURE:
        return { ...state, contactCardLoading: false, contactCardError: action.payload };  
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState          
      default:
        return state;
    }
  };
  
  export default contactCardReducer;
  